/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Typography, TypographyProps } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView.tsx";
import { serviceworldTheme } from "@/src/theme/Theme";

export default function TypographyStyleguide() {
  return (
    [
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "h7",
      "formLegend",
      "subtitle1",
      "subtitle2",
      "body1",
      "body2",
      "body3",
      "button",
      "caption",
      "overline",
    ] as NonNullable<TypographyProps["variant"]>[]
  ).map((variant) => {
    return (
      <StyleguideView key={variant} title={variant[0].toUpperCase() + variant.slice(1)}>
        {/^h[1-7]$/.test(variant) ? (
          <>
            <Typography>Öffentlicher Bereich (400)</Typography>
            <Typography variant={variant}>Lorem ipsum dolor sit</Typography>

            <ThemeProvider theme={serviceworldTheme}>
              <Typography>Servicewelt (600)</Typography>
              <Typography variant={variant}>Lorem ipsum dolor sit</Typography>
            </ThemeProvider>
          </>
        ) : (
          <Typography variant={variant}>Lorem ipsum dolor sit</Typography>
        )}
      </StyleguideView>
    );
  });
}
